module.exports = __webpack_public_path__ + "img/MCU-Block-Diagram.c0567c4a.png";